import { isSessionTrackingEnabled, isFileDownloadTrackingEnabled, isFormInteractionTrackingEnabled, isPageViewTrackingEnabled, } from '@amplitude/analytics-client-common';
import { LogLevel } from '@amplitude/analytics-types';
var notified = false;
export var detNotify = function (config) {
    if (notified) {
        return;
    }
    var enabledTracking = [
        isPageViewTrackingEnabled(config.defaultTracking) ? 'Page Views' : '',
        isSessionTrackingEnabled(config.defaultTracking) ? 'Sessions' : '',
        isFileDownloadTrackingEnabled(config.defaultTracking) ? 'File Downloads' : '',
        isFormInteractionTrackingEnabled(config.defaultTracking) ? 'Form Interactions' : '',
    ].filter(Boolean);
    var enabledTrackingString = enabledTracking.join(', ');
    if (enabledTracking.length) {
        var message = "Your Amplitude instance is configured to track ".concat(enabledTrackingString, ". Visit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.");
        config.loggerProvider.log(message);
        /* istanbul ignore if */
        if (config.logLevel < LogLevel.Verbose) {
            console.log(message);
        }
    }
    notified = true;
};
/**
 * @private
 * This function is meant for testing purposes only
 */
export var resetNotify = function () {
    notified = false;
};
//# sourceMappingURL=det-notification.js.map